export default {
  unselectedTabText: '请选择',
};
